import React, { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";

const CulturalPlacesLayout = () => {
  const [LDCs, setLDCs] = useState([]);
  const [provsOption, setProvsOption] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [cityOption, setCityOption] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const breadcrumb = {
    current_section: "Luoghi della Cultura",
    sections: [
      { name: "Home", route_name: null, params: [] },
      { name: "Luoghi", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();

        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));

        setProvsOption(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchProvs();
  }, []);

  const handleProvinceChange = (e) => {
    setSelectedProvince(e?.value);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  const handleCityChange = (e) => {
    setSelectedCity(e?.value);
  };

  const handleSearch = () => {
    if (!selectedProvince && !selectedCity && !nameFilter) {
      alert("Per favore, inserisci almeno un filtro di ricerca.");
      return;
    }

    const fetchLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllLDC?provinceId=${
            selectedProvince ?? ""
          }&townId=${selectedCity ?? ""}&name=${nameFilter ?? ""}`,
          fetchOptions
        );
        const result = await response.json();
        setLDCs(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchLDCs();
  };

  const handleDelete = (id) => {
    if (
      window.confirm(
        "Sei sicuro di voler eliminare questo luogo della cultura?"
      )
    ) {
      const deleteLDC = async () => {
        try {
          const fetchOptions = getFetchOptions(
            "application/x-www-form-urlencoded",
            [],
            "DELETE"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/deleteLDC?ldcId=${id}`,
            fetchOptions
          );

          const result = await response.json();
          if (result.error) {
            alert("Errore durante l'eliminazione del luogo della cultura");
            return;
          }

          setLDCs(LDCs.filter((place) => place.id !== id));
        } catch (error) {
          console.error(error);
        }
      };

      deleteLDC();
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* Filters */}
      <div className="card custom-card">
        <div className="card-header">Filtri ricerca</div>
        <div className="card-body">
          <div className="row align-items-end">
            {/* Province Filter */}
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Cerca Luogo della Cultura..."
                  onChange={(e) => {
                    setNameFilter(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group">
                <Select
                  options={provsOption}
                  id="province"
                  name="province"
                  value={provsOption.filter(function (option) {
                    return option.value === selectedProvince;
                  })}
                  onChange={handleProvinceChange}
                  classNames={"form-control"}
                  placeholder="Scegli provincia..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            <div className="col-12 col-lg-3">
              <div className="form-group">
                <Select
                  options={cityOption}
                  id="city"
                  name="city"
                  value={cityOption?.filter(function (option) {
                    return option.value === selectedCity;
                  })}
                  onChange={handleCityChange}
                  classNames={"form-control"}
                  placeholder="Scegli comune..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            {/* Search Button */}
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <button
                  id="btnSearch"
                  name="btnSearch"
                  className="searchButton btn btn-success w-100"
                  type="button"
                  onClick={handleSearch}
                >
                  Cerca
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Elenco Luoghi della Cultura</div>
            <div>
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    window.location.href = `/culturalPlaces/add`;
                  }}
                  type="button"
                  className="btn btn-primary text-uppercase"
                >
                  <i className="bi bi-plus-circle-fill"></i> Nuovo
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered custom-table">
              <thead>
                <tr>
                  <th width="10">ID</th>
                  <th width="200">Cover</th>
                  <th>Luogo della Cultura</th>
                  <th>Coordinate</th>
                  <th>Città</th>
                  <th width={"10%"}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {LDCs.map((place) => (
                  <tr key={place.id}>
                    <td>{place.id}</td>
                    <td>
                      <img
                        src={place.importLink ? place.importLink : ""}
                        height="100"
                      />
                    </td>
                    <td>{place.nome}</td>
                    <td>
                      Latitudine: {place.latitude} <br />
                      Longitudine: {place.longitude}
                    </td>
                    <td>
                      {place.Town
                        ? place.Town.nome + " (" + place.Province.codice + ")"
                        : place.Province.nome +
                          " (" +
                          place.Province.codice +
                          ")"}
                    </td>
                    <td>
                      <div className="btn-list">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() =>
                            (window.location.href = `/culturalPlaces/edit/${place.id}`)
                          }
                        >
                          <i className="align-middle bi bi-pencil"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(place.id)}
                        >
                          <i className="align-middle bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CulturalPlacesLayout;
